import { useRef, useEffect, EffectCallback, DependencyList } from 'react';

const useUpdateEffect = (effect: EffectCallback, dependencies: DependencyList) => {
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      return effect();
    }
    // eslint-disable-next-line @eslint-react/exhaustive-deps
  }, dependencies);
};

export { useUpdateEffect };
